import {
  DeleteOutlined,
  EditOutlined,
  ScheduleOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Form,
  Input,
  InputNumber,
  Modal,
  Popover,
  Space,
  Switch,
  Tag,
  Tooltip,
  message
} from 'antd';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import CurrencyInputCustom from '../../components/CurrencyInputCustom';
import CustomDatePicker from '../../components/CustomDatePicker';
import MonedaSelector from '../../components/MonedaSelector';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import TableAndFilters from '../../components/TableAndFilters';
import { currencyToNumber, errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import { fieldTypes } from '../../utils/filter-utils';
import AseguradoraEmpresaSelect from './componentes/AseguradoraEmpresaSelect';
import AseguradoraProductos from './componentes/AseguradoraProductosSelect';

function AseguradoraProducto() {
  const [aseguradoraempresaId, setAseguradoraEmpresaId] = useState();
  const [productoId, setProductoId] = useState();
  const [visible, setVisible] = useState(false);
  const [habilitado, setHabilitado] = useState(false);
  const [update, setUpdate] = useState(false);
  const [data, setData] = useState([]);
  const [activo, setActivo] = useState(true);
  const [telefonica, setTelefonica] = useState(false);
  const [presencial, setPresencial] = useState(false);
  const [buttonstate, setButtonstate] = useState(false);
  const [buttontext, setButtontext] = useState('Asignar');
  const [titlemodal, setTitlemodal] = useState('Configuracion de Producto');
  const [monedas, setMonedas] = useState([]);
  const [monedaSelected, setMonedaSelected] = useState();
  const [form] = Form.useForm();
  const [formAseguradora] = Form.useForm();
  const [url, setUrl] = useState();
  const tableRef = useRef();
  const history = useHistory();
  const {
    params: { id: idAseguradora }
  } = useRouteMatch();

  const styles = {
    form: { textAlign: 'left' },
    card: { marginBottom: 10, textAlign: 'left' }
  };

  const ESTADOS = {
    INACTIVO: 'Inactivo',
    ACTIVO: 'Activo'
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '8px',
      sortable: true
    },
    {
      title: 'Producto',
      dataIndex: ['producto', 'descripcion'],
      filterType: fieldTypes.STRING,
      sortable: true,
      width: '15%'
    },
    {
      title: 'Fecha de Inicio',
      dataIndex: 'fecha_inicio',
      filterType: fieldTypes.DATE,
      sortable: true,
      width: '10%'
    },
    {
      title: 'Fecha de Fin',
      dataIndex: 'fecha_fin',
      filterType: fieldTypes.DATE,
      sortable: true,
      width: '10%'
    },
    {
      title: 'Titulo',
      dataIndex: 'titulo',
      filterType: fieldTypes.STRING,
      width: '40%'
    },
    {
      title: 'Condiciones',
      dataIndex: 'condiciones',
      render: (condiciones) => {
        if (condiciones) {
          return (
            <Popover content={condiciones} title="Condiciones">
              <Button type="link">Ver</Button>
            </Popover>
          );
        }
        return null;
      }
    },
    {
      title: 'Propuesta',
      dataIndex: 'propuesta',
      render: (propuesta) => {
        if (propuesta) {
          return (
            <Popover content={propuesta} title="Propuesta">
              <Button type="link">Ver</Button>
            </Popover>
          );
        }
        return null;
      }
    },
    {
      title: 'Tasa',
      dataIndex: 'tasa',
      filterType: fieldTypes.NUMERIC,
      sortable: true,
      width: '20%'
    },
    {
      title: 'Comisión %',
      dataIndex: 'comision_porcentaje',
      filterType: fieldTypes.NUMERIC,
      sortable: true
    },
    {
      title: 'Costo sevicio',
      dataIndex: 'costo_servicio_monto',
      filterType: fieldTypes.NUMERIC,
      sortable: true
    },
    {
      title: 'Costo sevicio %',
      dataIndex: 'costo_servicio_porcentaje',
      filterType: fieldTypes.NUMERIC,
      sortable: true
    },
    {
      title: 'Activo',
      dataIndex: 'activo',
      render: (thisestado) => {
        let estadoUpperCase;
        let color = 'white';
        if (thisestado) {
          color = 'green';
          estadoUpperCase = 'ACTIVO';
        } else {
          color = 'orange';
          estadoUpperCase = 'INACTIVO';
        }
        return (
          <Tag color={color} key={estadoUpperCase}>
            {estadoUpperCase}
          </Tag>
        );
      },
      filterType: fieldTypes.ENUM,
      filters: Object.keys(ESTADOS).map((key) => ({
        text: ESTADOS[key],
        value: key
      })),
      sortable: true,
      width: '10%'
    },
    {
      title: 'Acciones',
      key: 'action',
      align: 'left',
      width: '10px',
      render: (text, record) => (
        <Space size="small">
          <Tooltip title="Editar">
            <Button
              type="text"
              icon={<EditOutlined />}
              size="middle"
              onClick={() => updateProducto(record)}
            />
          </Tooltip>
          <Tooltip title="Configurar Vigencia">
            <Button
              type="text"
              icon={<ScheduleOutlined />}
              size="middle"
              onClick={() => configurarVigencia(record)}
            />
          </Tooltip>
          <Tooltip title="Eliminar">
            <Button
              type="text"
              icon={<DeleteOutlined />}
              size="middle"
              onClick={() => deleteproducto(record)}
            />
          </Tooltip>
        </Space>
      )
    }
  ];

  const configurarVigencia = (record) => {
    history.push(`/vigencia/config/${record.id}`);
  };

  const handleOk = async () => {
    if (update) {
      await instanceRef.instance.post(
        `aseguradoraempresaproducto/update/${data.id}`,
        {
          tasa: form.getFieldValue('tasa'),
          titulo: form.getFieldValue('titulo'),
          condiciones: form.getFieldValue('condiciones'),
          propuesta: form.getFieldValue('propuesta'),
          comision_porcentaje: form.getFieldValue('comision_porcentaje'),
          costo_servicio_monto: form.getFieldValue('costo_servicio_monto'),
          costo_servicio_porcentaje: form.getFieldValue(
            'costo_servicio_porcentaje'
          ),
          fecha_inicio: form.getFieldValue('fechaini')
            ? moment(form.getFieldValue('fechaini'))
            : null,
          fecha_fin: form.getFieldValue('fechafin')
            ? moment(form.getFieldValue('fechafin'))
            : null,
          activo,
          venta_telefonica: telefonica,
          venta_presencial: presencial,
          monto_cumulo_gs: form.getFieldValue('monto_cumulo_gs'),
          monto_cumulo_usd: form.getFieldValue('monto_cumulo_usd')
        }
      );
      setUrl(`/aseguradoraempresaproducto/productos/${aseguradoraempresaId}`);
      setVisible(false);
      setUpdate(false);
      form.resetFields();
      setTelefonica(false);
      setPresencial(false);
      setData(null);
    } else {
      await instanceRef.instance.post(`aseguradoraempresaproducto/add`, {
        id_aseguradora_empresa: aseguradoraempresaId,
        id_producto: productoId,
        tasa: form.getFieldValue('tasa'),
        titulo: form.getFieldValue('titulo'),
        condiciones: form.getFieldValue('condiciones'),
        propuesta: form.getFieldValue('propuesta'),
        comision_porcentaje: form.getFieldValue('comision_porcentaje'),
        costo_servicio_monto: form.getFieldValue('costo_servicio_monto'),
        costo_servicio_porcentaje: form.getFieldValue(
          'costo_servicio_porcentaje'
        ),
        fecha_inicio: form.getFieldValue('fechaini')
          ? moment(form.getFieldValue('fechaini'))
          : null,
        fecha_fin: form.getFieldValue('fechafin')
          ? moment(form.getFieldValue('fechafin'))
          : null,
        activo,
        monto_cumulo_gs: form.getFieldValue('monto_cumulo_gs'),
        monto_cumulo_usd: form.getFieldValue('monto_cumulo_usd')
      });
      setUrl(`/aseguradoraempresaproducto/productos/${aseguradoraempresaId}`);
      setUpdate(false);
      setTelefonica(false);
      setPresencial(false);
      setVisible(false);
    }
  };

  const handleCancel = () => {
    setUpdate(false);
    setTelefonica(false);
    setPresencial(false);
    setVisible(false);
    form.resetFields();
  };

  const checkDate = () => {
    if (form.getFieldValue('fechaini') === null) {
      setButtonstate(false);
      return Promise.resolve();
    }
    if (form.getFieldValue('fechafin') === null) {
      setButtonstate(false);
      return Promise.resolve();
    }
    if (form.getFieldValue('fechaini') > form.getFieldValue('fechafin')) {
      setButtonstate(true);
      return Promise.reject(
        new Error('El fin de vigencia tiene que ser posterior al del incio')
      );
    }
    setButtonstate(false);
    return Promise.resolve();
  };

  const handleActivo = async (value) => {
    setActivo(value);
  };

  const handleTelefonica = async (value) => {
    setTelefonica(value);
  };

  const handlePresencial = async (value) => {
    setPresencial(value);
  };

  function getAseguradoraEmpresaId(value) {
    setAseguradoraEmpresaId(value.key);
    setUrl(`/aseguradoraempresaproducto/productos/${value.key}`);
    if (productoId > 0) {
      setHabilitado(true);
    }
  }

  const deleteproducto = async (record) => {
    const idaseguradoraempresaproducto = record.id;
    try {
      const response = await instanceRef.instance.get(
        `plan/all/${idaseguradoraempresaproducto}`
      );
      if (response.data.data.length > 0) {
        message.warning(
          'No se puede eliminar el producto, ya esta asociado a un plan.'
        );
      } else {
        await instanceRef.instance.post(`aseguradoraempresaproducto/delete`, {
          id: idaseguradoraempresaproducto
        });
        setUrl();
        setUrl(`/aseguradoraempresaproducto/productos/${aseguradoraempresaId}`);
        message.warning('Se ha eliminado el producto del la empresa.');
      }
    } catch {
      // error
    }
  };

  const updateProducto = async (record) => {
    setData(record);
    setButtontext('Actualizar');
    setTitlemodal('Modificar configuraciones del Producto');
    setUpdate(true);
    setVisible(true);
    if (record.fecha_inicio) {
      form.setFieldsValue({ fechaini: moment(record.fecha_inicio) });
    }
    if (record.fecha_fin) {
      form.setFieldsValue({ fechafin: moment(record.fecha_fin) });
    }
    form.setFieldsValue({ titulo: record.titulo });
    form.setFieldsValue({ condiciones: record.condiciones });
    form.setFieldsValue({ propuesta: record.propuesta });
    form.setFieldsValue({ tasa: record.tasa });
    form.setFieldsValue({ comision_porcentaje: record.comision_porcentaje });
    form.setFieldsValue({ costo_servicio_monto: record.costo_servicio_monto });
    form.setFieldsValue({
      costo_servicio_porcentaje: record.costo_servicio_porcentaje
    });
    handleActivo(!!record.activo);
    handleTelefonica(!!record.venta_telefonica);
    handlePresencial(!!record.venta_presencial);
    form.setFieldsValue({
      monto_cumulo_gs: record.monto_cumulo_gs
    });
    form.setFieldsValue({
      monto_cumulo_usd: record.monto_cumulo_usd
    });
  };

  const handleAsignar = async () => {
    /* const response = await instanceRef.instance.post(
      `/aseguradoraproducto/searchproducto`,
      {
        id_aseguradora: aseguradoraempresaId,
        id_producto: productoId
      }
    );
    if (response.data.data) {
      message.warning('La aseguradora ya posee el producto Activo');
    } else { */
    setButtontext('Asignar');
    setTitlemodal('Configuracion del Producto');
    setActivo(true);
    setVisible(true);
    // }
  };

  function getProductoId(id) {
    if (id > 0) {
      setProductoId(id);
      if (aseguradoraempresaId > 0) {
        setHabilitado(true);
      }
    } else {
      setHabilitado(false);
    }
  }

  const formatoPeso = (e) => {
    const specialCharRegex = new RegExp(/[a-zA-Z¡!@#=()$~%^°":,*¿?<>{}]/g);
    const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (specialCharRegex.test(pressedKey)) {
      e.preventDefault();
      return false;
    }
    return true;
  };
  const fetchMonedas = async () => {
    try {
      const monedasResponse = await instanceRef.instance.get(`/moneda`);
      setMonedaSelected(
        monedasResponse.data?.data.find(
          (item) => item.codigo.toString() === 'gs'
        )
      );
      setMonedas(monedasResponse.data?.data);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (url) {
      tableRef.current.reload();
    }
  }, [url]);

  useEffect(() => {
    fetchMonedas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ResponsiveContainer size="large">
      <Card
        title="Gestión de productos de las empresas"
        style={{ textAlign: 'left' }}
      >
        <Form form={formAseguradora} layout="vertical" style={styles.form}>
          <Form.Item label="Empresa:" name="empresa">
            <AseguradoraEmpresaSelect
              aseguradora={idAseguradora}
              getAseguradoraEmpresaId={getAseguradoraEmpresaId}
            />
          </Form.Item>
          <Form.Item label="Producto:" name="producto">
            <AseguradoraProductos
              aseguradora={idAseguradora}
              getProductoId={getProductoId}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              disabled={!habilitado}
              onClick={handleAsignar}
            >
              Asignar
            </Button>
          </Form.Item>
        </Form>

        <br />
        <TableAndFilters
          ref={tableRef}
          url={url}
          title="Productos de la Empresa"
          columns={columns}
          showTable
        />
      </Card>
      <Modal
        title={titlemodal}
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button type="primary" onClick={handleOk} disabled={buttonstate}>
            {buttontext}
          </Button>
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          name="usuarioForm"
          style={styles.form}
        >
          <Form.Item label="Titulo" name="titulo">
            <Input placeholder="Ingrese nombre del producto" />
          </Form.Item>
          <Form.Item
            label="Fecha de inicio de Vigencia"
            name="fechaini"
            rules={[{ validator: checkDate }]}
          >
            <CustomDatePicker
              style={{ width: '100%' }}
              placeholder="DD/MM/YYYY"
              format="DD/MM/YYYY"
            />
          </Form.Item>
          <Form.Item
            label="Fecha de fin de Vigencia"
            name="fechafin"
            rules={[{ validator: checkDate }]}
          >
            <CustomDatePicker
              style={{ width: '100%' }}
              placeholder="DD/MM/YYYY"
              format="DD/MM/YYYY"
            />
          </Form.Item>
          <Form.Item label="Condiciones" name="condiciones">
            <Input.TextArea placeholder="Ingrese las condiciones del producto" />
          </Form.Item>
          <Form.Item label="Propuesta" name="propuesta">
            <Input.TextArea placeholder="Ingrese propuesta del producto" />
          </Form.Item>
          <Form.Item
            label="Tasa"
            name="tasa"
            rules={[
              {
                validator: (_, valueParam) => {
                  if (valueParam < 0) {
                    return Promise.reject(
                      new Error('El valor ingresado debe ser mayor a cero')
                    );
                  }

                  return valueParam <= 100
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error(
                          'El valor ingresado supera el máximo admitido'
                        )
                      );
                }
              }
            ]}
            onKeyPress={formatoPeso}
          >
            <InputNumber
              step={0.1}
              min={0}
              precision={2}
              style={{
                display: 'inline-block',
                maxWidth: '90px'
              }}
            />
          </Form.Item>
          <Form.Item label="Comisión %" name="comision_porcentaje">
            <InputNumber
              step={1}
              min={0}
              max={100}
              style={{
                display: 'inline-block',
                maxWidth: '90px'
              }}
            />
          </Form.Item>
          <Form.Item label="Costo de Servicio" name="costo_servicio_monto">
            <InputNumber
              step={1}
              min={0}
              style={{
                display: 'inline-block',
                maxWidth: '150px'
              }}
            />
          </Form.Item>
          <Form.Item
            label="Costo de Servicio %"
            name="costo_servicio_porcentaje"
          >
            <InputNumber
              step={1}
              min={0}
              max={100}
              style={{
                display: 'inline-block',
                maxWidth: '90px'
              }}
            />
          </Form.Item>
          <Form.Item label="Activo" name="activo" rules={[{ required: true }]}>
            <Switch
              checkedChildren="Activo"
              unCheckedChildren="Inactivo"
              type="primary"
              onChange={handleActivo}
              checked={activo}
            />
          </Form.Item>
          <Form.Item
            label="Venta telefónica"
            name="ventatelefonica"
            rules={[{ required: true }]}
          >
            <Switch
              checkedChildren="Si"
              unCheckedChildren="No"
              type="primary"
              onChange={handleTelefonica}
              checked={telefonica}
            />
          </Form.Item>

          <Form.Item
            label="Venta presencial"
            name="ventapresencial"
            rules={[{ required: true }]}
          >
            <Switch
              checkedChildren="Si"
              unCheckedChildren="No"
              type="primary"
              onChange={handlePresencial}
              checked={presencial}
            />
          </Form.Item>

          {monedas && monedas.length > 0 && (
            <>
              <MonedaSelector
                value={monedaSelected.codigo}
                monedas={monedas}
                onChange={(e) => {
                  const selected = monedas.filter(
                    (mon) => mon.codigo === e.target.value
                  )[0];
                  setMonedaSelected(selected);
                }}
                // disabled={monedas.filter((item) => item.codigo === 'usd')}
              />
              <br />
              {monedaSelected && monedaSelected.codigo === 'gs' && (
                <Form.Item
                  label="Monto Cúmulo"
                  name="monto_cumulo_gs"
                  normalize={(value) => currencyToNumber(value, monedaSelected)}
                >
                  <CurrencyInputCustom
                    moneda={monedaSelected}
                    autoFocus
                    bordered
                    // disabled={rowInicial}
                  />
                </Form.Item>
              )}
              {monedaSelected && monedaSelected.codigo === 'usd' && (
                <Form.Item
                  label="Monto Cúmulo"
                  name="monto_cumulo_usd"
                  normalize={(value) => currencyToNumber(value, monedaSelected)}
                >
                  <CurrencyInputCustom
                    moneda={monedaSelected}
                    autoFocus
                    bordered
                    // disabled={rowInicial}
                  />
                </Form.Item>
              )}
            </>
          )}
        </Form>
      </Modal>
    </ResponsiveContainer>
  );
}
export default AseguradoraProducto;
